const taskTypeColors =  {
  deadline: '#ff0000',
  test: '#63ab91',
  jsTask: '#008000',
  htmltask: '#008000',
  selfeducation: '#008000',
  externaltask: '#008000',
  codewars: '#008000',
  codejam: '#008000',
  newtask: '#008000',
  lecture: '#0000ff',
  lectureOnline: '#0000ff',
  lectureOffline: '#0000ff',
  lectureMixed: '#0000ff',
  lectureSelfstudy: '#0000ff',
  info: '#ff7b00',
  warmup: '#63ab91',
  meetup: '#bde04a',
  workshop: '#bde04a',
  interview: '#63ab91',
  accessible: '#000000',
}

export default taskTypeColors;
